export interface ApprovalSubmitRequest {
  menuCode: string;
  noRef: string;
  /** 상신에 사용할 결재 양식. 메뉴에 양식이 여러 개일 때 양식도움창에서 선택한 값. */
  noForm?: string;
  userInfo: ApprovalSubmitUserInfo;
}

export interface ApprovalSubmitUserInfo {
  cd_firm?: string;
  cd_biz?: string;
  cd_dept?: string;
  cd_emp?: string;
  cd_user?: string;
}

export type ApprovalSubmitResult = any;

export const submitApproval = async (
  payload: ApprovalSubmitRequest
): Promise<ApprovalSubmitResult> => {
  const { callApi } = await import("@shared/api/restApi");
  return await callApi("approval/submit", payload);
};

/** 상신된 결재문서 다시 보기. 어떤 결재 건을 열지는 서버가 menuCode/noRef로 정한다. */
export const viewApproval = async (
  payload: ApprovalSubmitRequest
): Promise<ApprovalSubmitResult> => {
  const { callApi } = await import("@shared/api/restApi");
  return await callApi("approval/view", payload);
};
